export default __webpack_public_path__ + "static/7-31540f814ce2ecea235a9a9f738ddd9b.jpg";